import { Controller } from "stimulus"
import { nextFrame } from "../helpers"

export default class extends Controller {
  static targets = ["planInput", "planDescription"]

  initialize() {
    this.update()
  }

  async update() {
    const { selectedPlan } = this

    await nextFrame()

    for (const target of this.planDescriptionTargets) {
      target.hidden = target.dataset.plan != selectedPlan
    }
  }

  get selectedPlan() {
    return this.planInputTargets.find((input) => input.checked).value
  }
}
